import Approve from './index.vue'

export default {
	install (Vue, options = {}) {
		
		let approve = null;
		
		const VueApprove = Vue.extend(Approve);

		function $approve(params = {}) {
			
			if (!approve) {
				
				approve = new VueApprove();

				approve.$mount();
				
				document.querySelector(options.container || 'body').appendChild(approve.$el);
			}

			return approve.show(params, this);
		}

		Vue.prototype.$approve = $approve;
	}
}